import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    throw redirect({
      to: '/',
      replace: true,
      from: '/login',
    });
  },
  component: LoginRedirectPage,
});

function LoginRedirectPage() {
  return null;
}
